// Meta Pixel helper — fires standard events only when a Pixel ID is configured.
export const trackLead = (source) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", "Lead", { content_name: source || "WhatsApp CTA" });
  }
};
